export interface PaginationState {
  current: number;
  pageSize: number;
  total?: number;
}

export interface PageState {
  pagination: PaginationState;
  filters?: any;
  timestamp: number;
}

const STORAGE_KEY_PREFIX = 'page_state_';

// 生成页面状态存储键
const getStorageKey = (pagePath: string): string => {
  return `${STORAGE_KEY_PREFIX}${pagePath.replace(/\//g, '_')}`;
};

// 保存页面状态
export const savePageState = (pagePath: string, state: Omit<PageState, 'timestamp'>) => {
  try {
    const key = getStorageKey(pagePath);
    const pageState: PageState = {
      ...state,
      timestamp: Date.now(),
    };
    localStorage.setItem(key, JSON.stringify(pageState));
  } catch (error) {
    console.error(`保存页面状态失败 [${pagePath}]:`, error);
  }
};

// 获取页面状态
export const getPageState = (pagePath: string): PageState | null => {
  try {
    const key = getStorageKey(pagePath);
    const savedState = localStorage.getItem(key);
    if (savedState) {
      const state = JSON.parse(savedState);
      return state;
    }
    return null;
  } catch (error) {
    console.error(`获取页面状态失败 [${pagePath}]:`, error);
    return null;
  }
};

// 清除页面状态
export const clearPageState = (pagePath: string) => {
  try {
    const key = getStorageKey(pagePath);
    localStorage.removeItem(key);
  } catch (error) {
    console.error(`清除页面状态失败 [${pagePath}]:`, error);
  }
};

// 清除所有页面状态
export const clearAllPageStates = () => {
  try {
    const keys = Object.keys(localStorage);
    const pageStateKeys = keys.filter(key => key.startsWith(STORAGE_KEY_PREFIX));
    pageStateKeys.forEach(key => localStorage.removeItem(key));
  } catch (error) {
    console.error('清除所有页面状态失败:', error);
  }
};

// 清理过期的页面状态（超过24小时）
export const cleanupExpiredPageStates = () => {
  try {
    const keys = Object.keys(localStorage);
    const pageStateKeys = keys.filter(key => key.startsWith(STORAGE_KEY_PREFIX));
    const now = Date.now();
    const maxAge = 24 * 60 * 60 * 1000; // 24小时
    
    let cleanedCount = 0;
    pageStateKeys.forEach(key => {
      try {
        const stateStr = localStorage.getItem(key);
        if (stateStr) {
          const state = JSON.parse(stateStr);
          if (now - state.timestamp > maxAge) {
            localStorage.removeItem(key);
            cleanedCount++;
          }
        }
      } catch (error) {
        // 如果解析失败，直接删除
        localStorage.removeItem(key);
        cleanedCount++;
      }
    });
    
    if (cleanedCount > 0) {
      // 过期状态已清理
    }
  } catch (error) {
    console.error('清理过期页面状态失败:', error);
  }
};
